import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'shadow-sm' : ''}`} data-id="element-113">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-[90px] py-2" data-id="element-114">
        {/* Logo */}
        <a href="#inicio" className="flex items-center justify-center cursor-pointer h-full" data-id="element-115">
          <Logo width={200} data-id="element-116" />
        </a>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8" data-id="element-117">
          <a href="#inicio" className="text-brand-charcoal hover:text-brand-emerald font-medium transition-colors" data-id="element-118">
            Inicio
          </a>
          <a href="#productos" className="text-brand-charcoal hover:text-brand-emerald font-medium transition-colors" data-id="element-119">
            Productos
          </a>
          <a href="#nosotros" className="text-brand-charcoal hover:text-brand-emerald font-medium transition-colors" data-id="element-120">
            Sobre Nosotros
          </a>
        </div>

        {/* Desktop CTA */}
        <div className="hidden md:block" data-id="element-121">
          <a href="#productos" className="inline-flex items-center justify-center bg-brand-emerald text-white px-5 py-2.5 rounded-lg font-medium hover:bg-emerald-900 hover:scale-[1.02] transition-all duration-200" data-id="element-122">
            Ver productos &rarr;
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-brand-charcoal p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-123">
          {isMobileMenuOpen ? <X size={24} data-id="element-124" /> : <Menu size={24} data-id="element-125" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-lg py-4 px-6 flex flex-col gap-4" data-id="element-126">
          <a href="#inicio" className="text-brand-charcoal font-medium py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-127">
            Inicio
          </a>
          <a href="#productos" className="text-brand-charcoal font-medium py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-128">
            Productos
          </a>
          <a href="#nosotros" className="text-brand-charcoal font-medium py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-129">
            Sobre Nosotros
          </a>
          <a href="#productos" className="inline-flex items-center justify-center bg-brand-emerald text-white px-5 py-3 rounded-lg font-medium mt-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-130">
            Ver productos &rarr;
          </a>
        </div>}
    </nav>;
}